import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';
import getPersonAcknowledgementsAddAFamilyMember from './GetPersonAcknowledgementsAddAFamilyMember';
import postPersonAcknowledgementsAddAFamilyMember from './PostPersonAcknowledgementsAddAFamilyMember';

const INITIAL_STATE = { ...BASIC_INITIAL_STATE };

const PersonAcknowledgementAddAFamilyMemberData = { INITIAL_STATE, getPersonAcknowledgementsAddAFamilyMember, postPersonAcknowledgementsAddAFamilyMember };
export default PersonAcknowledgementAddAFamilyMemberData;
